import template from './deeplink-error.component.html';

angular
    .module('Toke')
    .component('appDeeplinkError', {
        template,
        bindings: {
            data: '<',
            state: '<'
        }
    });
